// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rq0nj","name":"styles_name__3blNa","phone":"styles_phone__3DmgW"};